import {Model} from 'vue-mc'

export default class Currency extends Model {
  defaults() {
    return {
      id: null,
      coode: null,
      symbol: null,
    }
  }

  async fetch() {
    const request = await this.createRequest({
      method: 'GET',
      url: `/api/v3/currencies`
    }).send();
    if(request.response.data) {
      return request.response.data;
    }
    return []
  }
}
